/** The one-line SkinSeoul Agent Plugin installers. They sign the person in, ask for their role and add the SkinSeoul MCP servers. */
export const AGENT_INSTALL_COMMANDS = {
  macosLinux: 'curl -fsSL https://static.skin-seoul.com/skinseoul-agent/install.sh | bash',
  windows: 'irm https://static.skin-seoul.com/skinseoul-agent/install.ps1 | iex',
} as const;

/** For someone who already has the plugin: adds any SkinSeoul MCP server they are missing, without asking for the role again. */
export const AGENT_ADD_MCP_COMMANDS = {
  macosLinux: '~/.skinseoul-agent/bin/skinseoul-agent-setup --mcp-only',
  windows: '& "$HOME\\.skinseoul-agent\\bin\\skinseoul-agent-setup.cmd" --mcp-only',
} as const;
